import { GridRowsProp } from "@mui/x-data-grid";
import { motion } from "motion/react";
import { useCallback, useMemo } from "react";

import StatusFilterItem from "@/components/table/StatusFilterItem";
import { hotelDepartureStatuses } from "@/constants/hotelDepartureStatuses";
import { PatientHotelDepartureStatuses } from "@/schemas/hotelPlanningDepartureSchema";
import {
    useHotelPlanningDepartureActions,
    useHotelPlanningDepartureFilterField,
} from "@/stores/use-hotel-planning-departure-table";

function HotelDepartureStatusFilter({ allRows }: { allRows: GridRowsProp }) {
    const statusFilter = useHotelPlanningDepartureFilterField("status");
    const { updateFilters } = useHotelPlanningDepartureActions();
    const activeStyle = useMemo(() => {
        if (!statusFilter) return false;
        const index = hotelDepartureStatuses.findIndex((item) => item.value === statusFilter);
        return index >= 0
            ? { translateX: `${index * 100}%`, backgroundColor: hotelDepartureStatuses[index].hover }
            : false;
    }, [statusFilter]);

    const vals = useMemo(
        () =>
            (allRows || []).reduce(
                (prev, curr) => {
                    const existed = hotelDepartureStatuses.some((item) => item.value === curr.status);
                    if (existed) prev[curr.status] += 1;
                    return prev;
                },
                {
                    [PatientHotelDepartureStatuses.PENDING]: 0,
                    [PatientHotelDepartureStatuses.IN_PROGRESS]: 0,
                    [PatientHotelDepartureStatuses.COMPLETED]: 0,
                }
            ),
        [allRows]
    );

    const handleUpdate = useCallback(
        (status: PatientHotelDepartureStatuses) => {
            updateFilters({ status: statusFilter === status ? null : status });
        },
        [statusFilter, updateFilters]
    );

    const filterElements = useMemo(
        () =>
            hotelDepartureStatuses.map((item) => (
                <StatusFilterItem<PatientHotelDepartureStatuses>
                    key={item.tooltip.title}
                    {...item}
                    active={item.value === statusFilter}
                    count={vals[item.value]}
                    handleUpdate={handleUpdate}
                />
            )),
        [statusFilter, handleUpdate, vals]
    );
    return (
        <div className=" relative py-1 h-full grid grid-cols-3 bg-gray-100/80  divide-x divide-gray-300    rounded">
            {filterElements}
            {activeStyle && (
                <motion.div
                    layoutId="hotel-departure-status-filter"
                    id="hotel-departure-status-filter"
                    animate={activeStyle}
                    transition={{ type: "tween" }}
                    className="  rounded-none absolute   !self-center  !h-[calc(100%-8px)]     !w-1/3 "
                ></motion.div>
            )}
        </div>
    );
}
export default HotelDepartureStatusFilter;
